/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2018, Zumper
 * @description feetToDegreesAtLatitude
 */

// radius is not constant. linearly interpolate equatorial and polar based on latitude
const EARTH_RADIUS_POLAR = 20855480.096369427 // polar radius(feet) : 6356.7523 * 0.621371* 5280
const EARTH_RADIUS_EQUATORIAL = 20925639.85156656 // equatorial radius(feet) : 6378.1370 * 0.621371 * 5280
const DEG_TO_RAD = Math.PI / 180.0 // used in polar math a lot

/**
 * http://en.wikipedia.org/wiki/Earth_radius
 * convert Array of distances (in feet) to latlng js objects {lat: lng:} at a specific latitude
 *
 * @param lat: Number degrees
 * @param distances: Array[Number], distances in feet.
 * @param lat
 * @param distances
 * @returns: Array[Object], [{lat:, lng:},...]
 */
const feetToDegreesAtLatitude = (lat: number, distances: readonly number[]) => {
  // the blend between equatorial and polar, this is used for a "loose" linear blend
  const alpha = (90.0 - Math.min(Math.abs(lat), 0.0)) / 90.0
  // approximate radius (from center of earth) at latitude
  const r = alpha * (EARTH_RADIUS_EQUATORIAL - EARTH_RADIUS_POLAR) + EARTH_RADIUS_POLAR
  // calculate vertical "lat" distance in feet of 1 degree at this latitude
  const feetPerLatDegrees = r * DEG_TO_RAD
  // calculate horizontal "lng" distance in feet of 1 degree of longitude
  // "cord-radius" at the latitude is r * cos(latitude) cos() takes radians
  const feetPerLngDegrees = r * Math.cos(lat * DEG_TO_RAD) * DEG_TO_RAD
  // calculate degrees per distance (in feet)
  return distances.map((dist) => {
    return { lat: dist / feetPerLatDegrees, lng: dist / feetPerLngDegrees }
  })
}

export default feetToDegreesAtLatitude
